import SiafLiteApiRepository from "../../external/siafLiteApi";

class CentroCustoService {
  constructor() {
    this.urlBase = "/financeiro/centro-custo";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  vinculoCentroCusto(centroCustoId) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/vinculo-centro-custo`,
    ).get({ centroCustoId });
  }
}

export default CentroCustoService;
